var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputMobileSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Name=Phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M1.429 1.6v12.8h7.142V1.6zM.714 0h8.572a.678.678 0 0 1 .505.234A.851.851 0 0 1 10 .8v14.4a.851.851 0 0 1-.209.566.678.678 0 0 1-.505.234H.714a.678.678 0 0 1-.505-.234A.851.851 0 0 1 0 15.2V.8A.851.851 0 0 1 .209.234.678.678 0 0 1 .714 0zM5 12a.678.678 0 0 1 .505.234.869.869 0 0 1 0 1.131.662.662 0 0 1-1.01 0 .869.869 0 0 1 0-1.131A.678.678 0 0 1 5 12z",
    transform: "translate(5 2)",
    style: {
      fill: "#212121"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputMobileSvg);
export default __webpack_public_path__ + "static/media/input-mobile-svg.845488e21b4488ab765d4d3142d98824.svg";
export { ForwardRef as ReactComponent };